import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadStatisticsDataFailed, loadStatisticsDataSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadStatisticsData(action) {
  try {
    const { payload: { filter } } = action;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/export/statistics/charts`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadStatisticsDataSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadStatisticsDataFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadStatisticsDataFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
